export const styleFormRadioGroupProps = {
  formControlProps: { style: { gap: '0.5rem' } },
  radioProps: { style: { padding: '0 9px 0 9px' } },
};
